"use client";

import { useEffect, useState } from "react";
import ProfileRouteShell from "@/components/user-button-pages/ProfileRouteShell";
import StudyProgressPage, {
  type StudyProgressTab,
} from "@/components/user-button-pages/StudyProgressPage";
import StudyProgressAside, {
  StudyProgressStickyControls,
} from "./StudyProgressAside";
import StudyProgressGuestMock from "./StudyProgressGuestMock";
import { ensureStudyProgressSnapshots } from "@/lib/server-actions/studyProgressSnapshotActions";

/**
 * 공부 진행상황 — 사용자 메뉴 항목 standalone 라우트 (JCG-2071 → JCG-2126).
 * 탭 상태를 라우트가 소유해 우측 사이드바(StudyProgressAside)와 본문(StudyProgressPage)이 공유한다.
 */
export default function StudyProgressRoute() {
  const [activeTab, setActiveTab] = useState<StudyProgressTab>("overview");

  // 진입 시 과거 회차 스냅샷을 1회 pre-warm(fire-and-forget, JCG-3284 §6).
  // 이용권 게이트 밖(라우트 최상위)에서 실행 — 서버 액션이 auth()만으로 게이트하며,
  // 비로그인/활동 없는 회차는 액션 내부에서 조용히 스킵한다.
  useEffect(() => {
    ensureStudyProgressSnapshots().catch(() => {});
  }, []);

  return (
    <ProfileRouteShell
      title="공부 진행상황"
      guestPreview={<StudyProgressGuestMock />}
      guestDescription="로그인하면 과목별 학습 진도와 정답률을 한눈에 볼 수 있어요."
      rightContext={
        <StudyProgressAside activeTab={activeTab} setActiveTab={setActiveTab} />
      }
      mobileTopContext={
        <StudyProgressStickyControls
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      }
      mobileRightContext={
        <StudyProgressAside
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          hideTabControl
        />
      }
    >
      <StudyProgressPage activeTab={activeTab} onTabChange={setActiveTab} />
    </ProfileRouteShell>
  );
}
